
// import React, { useState, useEffect } from 'react';
// import api from '../services/api';

// interface Indicator {
//   indicator_name: string;
//   category: string;
//   severity: string;
//   score_impact: number;
//   description: string;
//   recommendation: string;
//   evidence: any;
//   is_applicable?: boolean;
//   endpoint_url?: string;
// }

// interface Props {
//   open: boolean;
//   onClose: () => void;
//   indicator: Indicator | null;
//   vendorName?: string;
//   domain?: string;
//   vendorIp?: string;
//   vendorId?: string;
//   scanId?: string;
// }

// // Helper Functions
// const getRiskScore = (scoreImpact: number, severity: string): number => {
//   if (severity === 'Critical') return 85 + Math.min(15, Math.abs(scoreImpact));
//   if (severity === 'High') return 65 + Math.min(20, Math.abs(scoreImpact));
//   if (severity === 'Medium') return 40 + Math.min(25, Math.abs(scoreImpact));
//   if (severity === 'Low') return 15 + Math.min(25, Math.abs(scoreImpact));
//   return 5;
// };

// const getIndicatorId = (name: string): string => {
//   const prefix = name.toLowerCase().includes('ssl') || name.toLowerCase().includes('tls') ? 'SEC'
//     : name.toLowerCase().includes('vuln') ? 'VULN'
//     : name.toLowerCase().includes('dns') ? 'DNS'
//     : 'INFO';
//   const hash = Math.abs(name.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % 10000);
//   return `IND-${prefix}-${String(hash).padStart(6, '0')}`;
// };

// // Severity Badge Component
// const SeverityBadge: React.FC<{ severity: string }> = ({ severity }) => {
//   const config = {
//     Critical: { bg: '#FEF2F2', text: '#DC2626', border: '#FECACA', dot: '#DC2626' },
//     High: { bg: '#FFF7ED', text: '#EA580C', border: '#FED7AA', dot: '#EA580C' },
//     Medium: { bg: '#FFFBEB', text: '#D97706', border: '#FDE68A', dot: '#D97706' },
//     Low: { bg: '#F0FDF4', text: '#16A34A', border: '#BBF7D0', dot: '#16A34A' },
//     Info: { bg: '#EFF6FF', text: '#3B82F6', border: '#BFDBFE', dot: '#3B82F6' },
//   };
//   const style = config[severity as keyof typeof config] || config.Info;
  
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center', gap: '6px',
//       padding: '4px 12px', borderRadius: '20px',
//       background: style.bg, border: `1px solid ${style.border}`,
//       fontSize: '12px', fontWeight: '600', color: style.text,
//     }}>
//       <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: style.dot }} />
//       {severity}
//     </span>
//   );
// };

// // Applicability Badge Component
// const ApplicabilityBadge: React.FC<{ isApplicable?: boolean; endpointUrl?: string }> = ({ isApplicable, endpointUrl }) => {
//   if (isApplicable === false) {
//     return (
//       <span style={{
//         display: 'inline-flex', alignItems: 'center', gap: '6px',
//         padding: '4px 12px', borderRadius: '20px',
//         background: '#FEF2F2', border: '1px solid #FECACA',
//         fontSize: '12px', fontWeight: '600', color: '#DC2626',
//       }}>
//         <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#DC2626' }} />
//         ⚠️ Not Applicable (Non-Prod)
//       </span>
//     );
//   }
  
//   if (isApplicable === true) {
//     return (
//       <span style={{
//         display: 'inline-flex', alignItems: 'center', gap: '6px',
//         padding: '4px 12px', borderRadius: '20px',
//         background: '#F0FDF4', border: '1px solid #BBF7D0',
//         fontSize: '12px', fontWeight: '600', color: '#166534',
//       }}>
//         <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E' }} />
//         ✓ Applicable
//       </span>
//     );
//   }
  
//   return null;
// };

// // Status Badge
// const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
//   <span style={{
//     display: 'inline-flex', alignItems: 'center', gap: '6px',
//     padding: '4px 12px', borderRadius: '20px',
//     background: '#F0FDF4', border: '1px solid #BBF7D0',
//     fontSize: '12px', fontWeight: '500', color: '#166534',
//   }}>
//     <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E' }} />
//     {status}
//   </span>
// );

// // Tag Component
// const Tag: React.FC<{ label: string }> = ({ label }) => (
//   <span style={{
//     display: 'inline-block', padding: '2px 10px', borderRadius: '4px',
//     background: '#F3F4F6', border: '1px solid #E5E7EB',
//     fontSize: '11px', fontWeight: '500', color: '#4B5563',
//   }}>
//     {label}
//   </span>
// );

// // Info Row for Left Panel
// const InfoRow: React.FC<{ label: string; value: string | null | undefined }> = ({ label, value }) => {
//   if (!value || value === 'Not available' || value === '—' || value === 'null' || value === 'undefined') {
//     return null;
//   }
  
//   return (
//     <div style={{
//       display: 'flex', alignItems: 'center', padding: '10px 0',
//       borderBottom: '1px solid #F0F2F5',
//     }}>
//       <span style={{ width: '100px', fontSize: '11px', fontWeight: '500', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
//         {label}
//       </span>
//       <span style={{ flex: 1, fontSize: '13px', color: '#111827', fontWeight: '500' }}>
//         {value}
//       </span>
//     </div>
//   );
// };

// // UNIVERSAL HELPER - Formats ANY value for display
// const formatEvidenceValue = (value: any): string | React.ReactNode => {
//   if (value === null || value === undefined) return '—';
//   if (typeof value === 'boolean') return value ? 'Yes' : 'No';
//   if (typeof value === 'number') return value.toString();
//   if (typeof value === 'string') {
//     if (value.match(/^\d{4}-\d{2}-\d{2}/)) {
//       return new Date(value).toLocaleDateString();
//     }
//     return value;
//   }
  
//   if (value && typeof value === 'object' && value.exchange !== undefined && value.preference !== undefined) {
//     return (
//       <div style={{ 
//         padding: '8px 10px', 
//         background: '#F9FAFB', 
//         borderRadius: '6px',
//         border: '1px solid #E5E7EB',
//         marginBottom: '8px'
//       }}>
//         <div><strong>Preference:</strong> {value.preference}</div>
//         <div><strong>Exchange:</strong> {value.exchange}</div>
//         {value.ips && value.ips.length > 0 && (
//           <div style={{ marginTop: '4px' }}>
//             <strong>IPs:</strong>
//             <div style={{ marginLeft: '12px', marginTop: '2px' }}>
//               {value.ips.map((ip: any, idx: number) => (
//                 <div key={idx} style={{ fontSize: '11px', marginBottom: '2px' }}>
//                   {ip.ip} {ip.country ? `(${ip.country})` : ''} - {ip.owner || ip.as_number || ''}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         {value.response_time_ms && (
//           <div><strong>Response Time:</strong> {value.response_time_ms} ms</div>
//         )}
//       </div>
//     );
//   }
  
//   if (Array.isArray(value) && value.length > 0 && value[0]?.exchange !== undefined && value[0]?.preference !== undefined) {
//     return (
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//         {value.map((item, idx) => formatEvidenceValue(item))}
//       </div>
//     );
//   }
  
//   if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
//     if (typeof value[0] === 'string') {
//       return value.join(', ');
//     }
    
//     return (
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//         {value.map((item, idx) => {
//           if (typeof item === 'object' && item !== null) {
//             return (
//               <div key={idx} style={{ 
//                 padding: '8px 10px', 
//                 background: '#F9FAFB', 
//                 borderRadius: '6px',
//                 border: '1px solid #E5E7EB'
//               }}>
//                 {Object.entries(item).map(([k, v]) => {
//                   let displayValue = v;
//                   if (typeof v === 'boolean') displayValue = v ? 'Yes' : 'No';
//                   if (typeof v === 'object') displayValue = JSON.stringify(v);
//                   if (v === null || v === undefined) return null;
//                   if (Array.isArray(v) && v.length === 0) return null;
//                   return (
//                     <div key={k} style={{ fontSize: '11px', marginTop: '2px', color: '#6B7280' }}>
//                       <span style={{ fontWeight: '500' }}>{k}:</span> {String(displayValue)}
//                     </div>
//                   );
//                 }).filter(Boolean)}
//               </div>
//             );
//           }
//           return formatEvidenceValue(item);
//         })}
//       </div>
//     );
//   }
  
//   if (Array.isArray(value)) {
//     if (value.length === 0) return 'None';
//     return value.join(', ');
//   }
  
//   if (typeof value === 'object') {
//     const entries = Object.entries(value);
//     if (entries.length === 0) return '—';
    
//     if (entries.length <= 3) {
//       return (
//         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px' }}>
//           {entries.map(([k, v]) => (
//             <span key={k} style={{ fontSize: '12px' }}>
//               <strong>{k}:</strong> {typeof v === 'object' ? JSON.stringify(v) : String(v)}
//             </span>
//           ))}
//         </div>
//       );
//     }
    
//     return (
//       <div style={{ 
//         maxHeight: '300px', 
//         overflowY: 'auto',
//         border: '1px solid #E5E7EB',
//         borderRadius: '6px',
//         fontSize: '11px'
//       }}>
//         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//           <tbody>
//             {entries.map(([k, v]) => {
//               let displayValue = v;
//               if (typeof v === 'boolean') displayValue = v ? 'Yes' : 'No';
//               if (typeof v === 'object') displayValue = JSON.stringify(v);
//               if (v === null || v === undefined) return null;
//               return (
//                 <tr key={k} style={{ borderBottom: '1px solid #F0F2F5' }}>
//                   <td style={{ padding: '6px 10px', fontWeight: '600', color: '#6B7280', width: '120px' }}>
//                     {k}:
//                   </td>
//                   <td style={{ padding: '6px 10px', color: '#111827' }}>
//                     {String(displayValue)}
//                   </td>
//                 </tr>
//               );
//             }).filter(Boolean)}
//           </tbody>
//         </table>
//       </div>
//     );
//   }
  
//   return String(value);
// };

// // Evidence Row Component
// const EvidenceRow: React.FC<{ label: string; value: any }> = ({ label, value }) => {
//   const formattedLabel = label
//     .replace(/_/g, ' ')
//     .replace(/([A-Z])/g, ' $1')
//     .split(' ')
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ')
//     .trim();
  
//   const displayValue = formatEvidenceValue(value);
  
//   return (
//     <tr style={{ borderBottom: '1px solid #F0F2F5' }}>
//       <td style={{ padding: '10px 16px', fontSize: '12px', color: '#6B7280', width: '140px', verticalAlign: 'top' }}>
//         {formattedLabel}:
//       </td>
//       <td style={{ padding: '10px 16px', fontSize: '12px', color: '#111827', fontWeight: '500' }}>
//         {displayValue}
//       </td>
//     </tr>
//   );
// };

// // Main Component
// export default function IndicatorDetailModal({ 
//   open, 
//   onClose, 
//   indicator, 
//   vendorName, 
//   domain, 
//   vendorIp,
//   vendorId, 
//   scanId 
// }: Props) {
//   const [mitre, setMitre] = useState<any>(null);
//   const [loadingMitre, setLoadingMitre] = useState(false);
//   const [showEndpointsModal, setShowEndpointsModal] = useState(false);

//   useEffect(() => {
//     if (!indicator || !open) return;
//     setMitre(null);
    
//     setLoadingMitre(true);
//     api.get(`/v1/mitre/indicator/${encodeURIComponent(indicator.indicator_name)}/mitre`)
//       .then(res => setMitre(res.data))
//       .catch(() => setMitre(null))
//       .finally(() => setLoadingMitre(false));
//   }, [indicator, open]);

//   if (!open || !indicator) return null;

//   const evidence = indicator.evidence || {};
  
//   const source = evidence.source || (() => {
//     const cat = indicator.category?.toLowerCase() || '';
//     if (cat.includes('tls') || cat.includes('ssl') || cat.includes('encrypt')) return 'SSL Labs API';
//     if (cat.includes('dns')) return 'DNS Analyzer';
//     if (cat.includes('email')) return 'DMARC Analyzer';
//     if (cat.includes('network')) return 'Network Scanner';
//     if (cat.includes('cubit')) return 'Cubit Score Engine';
//     return 'Security Scanner';
//   })();

//   let confidence: number | null = null;
//   if (evidence.confidence) {
//     if (typeof evidence.confidence === 'number') {
//       confidence = evidence.confidence;
//     } else if (typeof evidence.confidence === 'string') {
//       const confidenceMap: Record<string, number> = {
//         'High': 95, 'Medium': 85, 'Low': 70, 'Critical': 98, 'Info': 50
//       };
//       confidence = confidenceMap[evidence.confidence] || null;
//     }
//   }
  
//   let ipAddress: string | null = evidence.ip || evidence.ip_address || vendorIp || null;
//   if (ipAddress === 'None' || ipAddress === 'N/A' || ipAddress === 'Unknown') {
//     ipAddress = null;
//   }

//   const status = evidence.status || (indicator.severity === 'Info' ? 'Resolved' : 'Active');
//   const scanType = evidence.scan_type || evidence.scan || "Full Scan";
//   const occurrences = evidence.occurrences ?? evidence.occurrence_count ?? null;
//   const subcategory = indicator.category?.split(' ')[0] || 'Security';
  
//   const tags = [
//     subcategory,
//     indicator.severity === 'Critical' ? 'Critical' : 
//     indicator.severity === 'High' ? 'High' : 
//     indicator.severity === 'Medium' ? 'Medium' : 
//     indicator.severity === 'Low' ? 'Low' : 'Info'
//   ].filter(Boolean);

//   const excludeFromEvidence = [
//     'vendor', 'domain', 'asset_domain', 'ip', 'ip_address',
//     'first_detected', 'last_detected', 'scan_type', 'occurrences',
//     'confidence', 'source', 'timestamp', '_id', 'indicator',
//     'rating', 'status', 'message', 'risk_score', 'score',
//     'description', 'recommendation', 'indicator_name', 'category', 'severity'
//   ];

//   const evidenceEntries = Object.entries(evidence).filter(([key, value]) => 
//     !excludeFromEvidence.includes(key) && 
//     value !== null && 
//     value !== undefined && 
//     value !== '' &&
//     !(typeof value === 'object' && Object.keys(value).length === 0)
//   );

//   const riskScore = getRiskScore(indicator.score_impact, indicator.severity);
//   const indicatorId = getIndicatorId(indicator.indicator_name);
//   const riskColor = riskScore >= 70 ? '#DC2626' : riskScore >= 40 ? '#F59E0B' : '#10B981';

//   const hasSuccess = indicator.description?.includes('✅') || indicator.description?.includes('EXCELLENT');
//   const hasWarning = indicator.description?.includes('⚠️') || indicator.description?.includes('CAUTION');
//   const hasInfo = indicator.description?.includes('ℹ️') || indicator.description?.includes('INFO:');

//   let descriptionBg = '#F9FAFB';
//   let descriptionBorder = '#E5E7EB';
//   let descriptionTextColor = '#374151';
  
//   if (hasSuccess) {
//     descriptionBg = '#F0FDF4';
//     descriptionBorder = '#BBF7D0';
//     descriptionTextColor = '#166534';
//   } else if (hasWarning) {
//     descriptionBg = '#FFFBEB';
//     descriptionBorder = '#FDE68A';
//     descriptionTextColor = '#92400E';
//   } else if (hasInfo) {
//     descriptionBg = '#EFF6FF';
//     descriptionBorder = '#BFDBFE';
//     descriptionTextColor = '#1E40AF';
//   }

//   // Import the endpoints modal dynamically to avoid circular imports
//   const AffectedEndpointsModal = React.lazy(() => import('./AffectedEndpointsModal'));

//   return (
//     <>
//       <div
//         onClick={onClose}
//         style={{
//           position: 'fixed', inset: 0, zIndex: 1300,
//           background: 'rgba(0, 0, 0, 0.5)',
//           backdropFilter: 'blur(2px)',
//           display: 'flex', alignItems: 'center', justifyContent: 'center',
//           padding: '24px',
//         }}
//       >
//         <div
//           onClick={e => e.stopPropagation()}
//           style={{
//             width: '100%', maxWidth: '900px', maxHeight: '90vh',
//             display: 'flex', flexDirection: 'column',
//             background: '#FFFFFF', borderRadius: '12px',
//             border: '1px solid #E5E7EB', overflow: 'hidden',
//             boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//           }}
//         >
//           {/* Header */}
//           <div style={{ padding: '20px 24px', borderBottom: '1px solid #E5E7EB', background: '#FFFFFF' }}>
//             <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
//               <div style={{ flex: 1 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
//                   <h2 style={{ margin: 0, fontSize: '22px', fontWeight: '600', color: '#111827' }}>
//                     {indicator.indicator_name}
//                   </h2>
//                   <SeverityBadge severity={indicator.severity} />
//                   <ApplicabilityBadge 
//                     isApplicable={indicator.is_applicable} 
//                     endpointUrl={indicator.endpoint_url}
//                   />
//                 </div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px' }}>
//                   <span style={{ fontSize: '12px', color: '#6B7280', fontFamily: 'monospace' }}>
//                     ID: {indicatorId}
//                   </span>
//                 </div>
//               </div>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//                 <div style={{ textAlign: 'center' }}>
//                   <div style={{ fontSize: '28px', fontWeight: '700', color: riskColor }}>
//                     {riskScore}<span style={{ fontSize: '14px', color: '#9CA3AF', fontWeight: '400' }}>/100</span>
//                   </div>
//                   <p style={{ margin: '4px 0 0', fontSize: '11px', fontWeight: '500', color: '#6B7280' }}>
//                     Risk Score
//                   </p>
//                 </div>
//                 <button
//                   onClick={onClose}
//                   style={{
//                     width: '32px', height: '32px', borderRadius: '6px',
//                     border: '1px solid #E5E7EB', background: '#FFFFFF',
//                     cursor: 'pointer', fontSize: '18px', color: '#9CA3AF',
//                     display: 'flex', alignItems: 'center', justifyContent: 'center',
//                   }}
//                   onMouseEnter={e => { e.currentTarget.style.background = '#F3F4F6'; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = '#FFFFFF'; }}
//                 >
//                   ×
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Main Content - 2 Columns */}
//           <div style={{ flex: 1, overflow: 'hidden', display: 'flex', background: '#F9FAFB' }}>

//             {/* LEFT PANEL - Metadata */}
//             <div style={{ 
//               width: '280px', 
//               flexShrink: 0, 
//               background: '#FFFFFF', 
//               borderRight: '1px solid #E5E7EB',
//               overflowY: 'auto',
//               maxHeight: '100%'
//             }}>
//               <div style={{ padding: '16px' }}>
//                 <InfoRow label="Category" value={indicator.category} />
//                 <InfoRow label="Subcategory" value={subcategory} />
//                 <InfoRow label="Source" value={source} />
//                 <InfoRow label="Vendor" value={vendorName || evidence.vendor} />
//                 <InfoRow label="Asset / Domain" value={domain || evidence.domain || evidence.asset_domain} />
//                 <InfoRow label="IP Address" value={ipAddress} />
//                 <InfoRow label="Status" value={status} />
//                 {confidence && <InfoRow label="Confidence" value={`${confidence}%`} />}
//                 <InfoRow label="Scan Type" value={scanType} />
//                 {occurrences && <InfoRow label="Occurrences" value={String(occurrences)} />}
//                 <InfoRow 
//                   label="Applicability" 
//                   value={indicator.is_applicable === false ? 'Not Applicable (Non-Prod)' : 
//                          indicator.is_applicable === true ? 'Applicable' : 'Unknown'} 
//                 />

//                 {tags.length > 0 && (
//                   <div style={{ marginTop: '16px', paddingTop: '8px', borderTop: '1px solid #E5E7EB' }}>
//                     <p style={{ margin: '0 0 10px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                       Tags
//                     </p>
//                     <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
//                       {tags.map((tag, idx) => <Tag key={idx} label={tag} />)}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* RIGHT PANEL - Details */}
//             <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>

//               {/* Description Section */}
//               <div style={{ marginBottom: '20px' }}>
//                 <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Description</h3>
//                 <div style={{ 
//                   background: descriptionBg, 
//                   borderRadius: '8px', 
//                   padding: '16px', 
//                   border: `1px solid ${descriptionBorder}`,
//                   whiteSpace: 'pre-wrap'
//                 }}>
//                   <p style={{ margin: 0, fontSize: '13px', color: descriptionTextColor, lineHeight: 1.6 }}>
//                     {indicator.description}
//                   </p>
//                 </div>
//                 {indicator.is_applicable === false && (
//                   <div style={{ 
//                     marginTop: '12px', 
//                     padding: '10px 16px', 
//                     background: '#FEF2F2', 
//                     border: '1px solid #FECACA', 
//                     borderRadius: '8px',
//                     fontSize: '12px',
//                     color: '#DC2626'
//                   }}>
//                     ℹ️ <strong>Note:</strong> This finding is from a Non-Production subdomain and does <strong>not</strong> affect the vendor's risk score.
//                   </div>
//                 )}
//               </div>

//               {/* Evidence Details Section */}
//               {evidenceEntries.length > 0 && (
//                 <div style={{ marginBottom: '20px' }}>
//                   <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Evidence Details</h3>
//                   <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '8px', overflow: 'hidden' }}>
//                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                       <tbody>
//                         {evidenceEntries.map(([key, value]) => (
//                           <EvidenceRow key={key} label={key} value={value} />
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* MITRE ATT&CK Section */}
//               <div style={{ marginBottom: '20px' }}>
//                 <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>MITRE ATT&CK Mapping</h3>
//                 <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '8px', overflow: 'hidden' }}>
//                   {loadingMitre ? (
//                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
//                       <div style={{ width: '24px', height: '24px', border: '2px solid #E5E7EB', borderTopColor: '#3B82F6', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
//                     </div>
//                   ) : mitre && (mitre.tactic || mitre.technique_id) ? (
//                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                       <thead>
//                         <tr style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
//                           <th style={{ textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: '600', color: '#6B7280' }}>Tactics</th>
//                           <th style={{ textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: '600', color: '#6B7280' }}>Technique ID</th>
//                           <th style={{ textAlign: 'left', padding: '12px 16px', fontSize: '11px', fontWeight: '600', color: '#6B7280' }}>Technique Name</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td style={{ padding: '12px 16px', fontSize: '12px', color: '#374151' }}>{mitre.tactic || 'Initial Access'}</td>
//                           <td style={{ padding: '12px 16px', fontSize: '12px', fontFamily: 'monospace', color: '#374151' }}>{mitre.technique_id || 'Not available'}</td>
//                           <td style={{ padding: '12px 16px', fontSize: '12px', color: '#374151' }}>{mitre.technique_name || 'Not available'}</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   ) : (
//                     <div style={{ padding: '20px', textAlign: 'center' }}>
//                       <p style={{ margin: 0, fontSize: '12px', color: '#9CA3AF' }}>No MITRE mapping available</p>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Recommendation Section */}
//               <div style={{ marginBottom: '20px' }}>
//                 <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Recommendation</h3>
//                 <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '8px', padding: '16px' }}>
//                   <p style={{ margin: 0, fontSize: '13px', color: '#1E40AF', lineHeight: 1.6 }}>
//                     {indicator.recommendation}
//                   </p>
//                 </div>
//               </div>

//               {/* Remediation Reference */}
//               <div style={{ marginBottom: '20px' }}>
//                 <h3 style={{ margin: '0 0 12px', fontSize: '14px', fontWeight: '600', color: '#111827' }}>Remediation Reference</h3>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
//                   {mitre?.technique_id && <Tag label={`MITRE ${mitre.technique_id}`} />}
//                   <Tag label="NIST SP 800-52 Rev. 2" />
//                   <Tag label="CVE-2016-2183" />
//                 </div>
//               </div>

//               {/* View in Context */}
//               <div style={{ marginTop: '16px', textAlign: 'right' }}>
//                 <a 
//                   href="#" 
//                   style={{ fontSize: '12px', color: '#3B82F6', textDecoration: 'none', fontWeight: '500' }} 
//                   onClick={(e) => e.preventDefault()}
//                 >
//                   View in Context →
//                 </a>
//               </div>
//             </div>
//           </div>

//           {/* Footer */}
//           <div style={{ padding: '12px 20px', borderTop: '1px solid #E5E7EB', background: '#FFFFFF', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            
//             {/* View Affected Endpoints Button */}
//             <button
//               onClick={() => setShowEndpointsModal(true)}
//               style={{
//                 padding: '8px 20px', borderRadius: '6px', fontSize: '13px', fontWeight: '500',
//                 background: '#FFFFFF', border: '1px solid #3B82F6', color: '#3B82F6', cursor: 'pointer',
//                 display: 'flex', alignItems: 'center', gap: '8px',
//               }}
//               onMouseEnter={e => { e.currentTarget.style.background = '#EFF6FF'; }}
//               onMouseLeave={e => { e.currentTarget.style.background = '#FFFFFF'; }}
//             >
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <circle cx="12" cy="12" r="10"/>
//                 <line x1="12" y1="16" x2="12" y2="12"/>
//                 <line x1="12" y1="8" x2="12.01" y2="8"/>
//               </svg>
//               View Affected Endpoints
//             </button>

//             <button
//               onClick={onClose}
//               style={{
//                 padding: '8px 20px', borderRadius: '6px', fontSize: '13px', fontWeight: '500',
//                 background: '#FFFFFF', border: '1px solid #E5E7EB', color: '#374151', cursor: 'pointer',
//               }}
//               onMouseEnter={e => { e.currentTarget.style.background = '#F9FAFB'; }}
//               onMouseLeave={e => { e.currentTarget.style.background = '#FFFFFF'; }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={() => {
//                 const txt = `SECURITY INDICATOR REPORT\n${'='.repeat(60)}\n\nIndicator: ${indicator.indicator_name}\nID: ${indicatorId}\nCategory: ${indicator.category}\nSeverity: ${indicator.severity}\nRisk Score: ${riskScore}/100\nApplicable: ${indicator.is_applicable === false ? 'No (Non-Prod)' : 'Yes'}\nIP Address: ${ipAddress || 'Not available'}\n\nDescription:\n${indicator.description}\n\nRecommendation:\n${indicator.recommendation}\n\nEvidence:\n${JSON.stringify(indicator.evidence, null, 2)}\n\nGenerated: ${new Date().toLocaleString()}`;
//                 const a = document.createElement('a');
//                 a.href = URL.createObjectURL(new Blob([txt], { type: 'text/plain' }));
//                 a.download = `${indicator.indicator_name.replace(/\s/g, '_')}_report.txt`;
//                 a.click();
//               }}
//               style={{
//                 padding: '8px 20px', borderRadius: '6px', fontSize: '13px', fontWeight: '500',
//                 background: '#111827', border: 'none', color: '#FFFFFF', cursor: 'pointer',
//               }}
//               onMouseEnter={e => { e.currentTarget.style.background = '#374151'; }}
//               onMouseLeave={e => { e.currentTarget.style.background = '#111827'; }}
//             >
//               Export Report
//             </button>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       {/* Affected Endpoints Modal */}
//       <React.Suspense fallback={null}>
//         <AffectedEndpointsModal
//           open={showEndpointsModal}
//           onClose={() => setShowEndpointsModal(false)}
//           indicatorName={indicator.indicator_name}
//           vendorId={vendorId}  
//           domain={domain}    
//         />
//       </React.Suspense>
//     </>
//   );
// }

import React, { useEffect, useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import { useTheme as useCustomTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { ACRONYM_WORDS } from '../utils/textFormat';

// Indicator detail. Everything shown comes from the finding itself or from GET /v1/indicator-intel (the finding's
// standards mappings resolved live from MITRE ATT&CK / CWE, CVE facts from CISA KEV / FIRST EPSS / NVD, the framework
// controls the Security Profile uses, this check's history across scans, and its remediation status). Nothing here is
// made up: a field with no real value is not shown.

const RequestRemediationModal = React.lazy(() => import('../pages/Remediation/RequestRemediationModal'));

interface Indicator {
  indicator_name: string;
  category: string;
  severity: string;
  score_impact: number;
  description: string;
  recommendation: string;
  evidence: any;
  is_applicable?: boolean;
  endpoint_url?: string;
  protocol?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  indicator: Indicator | null;
  vendorName?: string;
  domain?: string;
  vendorIp?: string;
  vendorId?: string;
  scanId?: string;
  /** The list the finding was opened from, for previous / next. */
  list?: Indicator[];
  onNavigate?: (indicator: Indicator) => void;
  /** 'drawer' opens as a panel on the right (scan results page) so the list stays in view; default is a centred window. */
  variant?: 'modal' | 'drawer';
  /** Points the overall score would rise if this finding alone were fixed (scan context endpoint), when known. */
  scoreGain?: number | null;
}

interface Technique {
  id: string; relation: 'defends' | 'enables' | 'indicates' | 'recon'; relation_label: string; why: string;
  resolved: boolean; name?: string; parent_name?: string; tactics?: string[]; matrix?: string; url: string;
  description?: string; mitigations?: { id: string; name: string; url: string; how: string }[];
}
interface Weakness {
  id: string; name?: string; url: string; resolved: boolean; description?: string; owasp_2021?: string[];
  mitigations?: { phase: string | null; text: string }[];
}
interface CveInfo {
  id: string; url: string; description: string | null; cvss: { version: string; score: number; severity: string; vector: string } | null;
  nvd_status: 'ok' | 'pending' | 'not_found'; kev: { date_added: string; due_date: string; ransomware: boolean; name: string; action: string } | null;
  epss: { score: number; percentile: number } | null;
}
interface Intel {
  scan_id: string; scan_ref: string | null; scan_type: string | null; scanned_at: string | null; host: string;
  indicator_name: string; category: string; catalogued: boolean;
  knowledge: null | {
    kind: 'security' | 'intel' | 'composite' | 'informational' | 'business'; note: string | null;
    attack: { techniques: Technique[]; available: boolean; version: string | null };
    cwe: { weaknesses: Weakness[]; owasp_2021: string[]; available: boolean; version: string | null };
    cves: { found_in_evidence: CveInfo[]; evidence_total: number; check_targets: CveInfo[] };
    kev_products: null | { total: number; ransomware: number; items: (CveInfo & { cve: string; vendor: string; product: string; name: string; date_added: string; ransomware: boolean })[] };
  };
  frameworks: { framework: string; controls: { id: string; title: string; family: string }[] }[];
  history: { scan_id: string; ref: string | null; date: string; scan_type: string | null; present: boolean; severity: string | null; score_impact: number | null; value: string | null }[];
  remediation: null | { id: string; title: string; status: string; due_date: string | null; risk_status: string };
}

// ─── palette ──────────────────────────────────────────────────────────────────────────────────────────────────────
const palette = (d: boolean) => ({
  ink: d ? '#e2e8f0' : '#0F172A', body: d ? '#cbd5e1' : '#334155', muted: d ? '#94a3b8' : '#64748B', faint: d ? '#64748b' : '#94A3B8',
  line: d ? '#1f1f1f' : '#E5E7EB', soft: d ? '#141414' : '#F8FAFC', card: d ? '#0d0d0d' : '#FFFFFF', page: d ? '#050505' : '#F8FAFC',
  blue: d ? '#60A5FA' : '#2563EB', code: d ? '#0a0a0a' : '#F8FAFC',
});
const SEV: Record<string, string> = { Critical: '#DC2626', High: '#EA580C', Medium: '#D97706', Low: '#CA8A04', Info: '#2563EB' };
const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

// ─── text helpers ─────────────────────────────────────────────────────────────────────────────────────────────────
const EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}\u{20E3}]/gu;
const clean = (s: string) => s.replace(EMOJI_RE, '').replace(/\s+\n/g, '\n').trim();
const humanize = (key: string) => key.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim().split(/\s+/)
  .map(w => ACRONYM_WORDS[w.toLowerCase()] || w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
const titleCase = (s: string) => /^[A-Z0-9 _\-/.]+$/.test(s) && s.length > 3
  ? s.toLowerCase().replace(/(^|[\s/(-])([a-z])/g, (_, a, b) => a + b.toUpperCase()) : s;
const isUrl = (s: string) => /^https?:\/\/[^\s]+$/i.test(s);
const ISO_RE = /^\d{4}-\d{2}-\d{2}([T ][\d:.]+(Z|[+-]\d{2}:?\d{2})?)?$/;
const fmtDate = (v: string | null | undefined, withTime = false) => {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return String(v);
  return withTime ? d.toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};
const looksLikeRecord = (s: string) => /^(v=|k=|p=|\S+=\S+;)/i.test(s) || (s.length > 60 && !/\s/.test(s.slice(0, 40)));
const GENERIC_FIX = /^\s*(review and address identified issues\.?|no action (needed|required)\.?|n\/a)?\s*$/i;
const NOT_TESTED_RE = /NOT APPLICABLE|UNABLE TO TEST|NOT TESTED|COULD NOT BE (TESTED|ASSESSED)|UNAVAILABLE|INCONCLUSIVE/i;

/** A finding's state as one label, shared with the scan results table so both say the same thing: Not tested when
 *  the check couldn't get an answer, the severity when it flagged a risk, else Passed. */
export function findingState(ind: { severity?: string; evidence?: any }): { label: string; color: string } {
  const ev = ind.evidence && typeof ind.evidence === 'object' && !Array.isArray(ind.evidence) ? ind.evidence : {};
  if (NOT_TESTED_RE.test(`${ev.value ?? ''} ${ev.rating ?? ''}`)) return { label: 'Not tested', color: '#64748B' };
  if (['Critical', 'High', 'Medium', 'Low'].includes(ind.severity || '')) return { label: ind.severity!, color: SEV[ind.severity!] };
  return { label: 'Passed', color: '#16A34A' };
}
const isEmpty = (v: any) => v === null || v === undefined || v === '' ||
  (Array.isArray(v) && v.length === 0) || (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0);

// Keys of the evidence object that are shown elsewhere in the view (result, source, confidence) or are internal.
const META_KEYS = new Set(['observed', 'indicator', 'risk_score', 'severity', 'value', 'rating', 'confidence', 'source', 'description',
  'recommendation', 'indicator_name', 'category', 'score', 'score_impact']);

// ─── small UI pieces ──────────────────────────────────────────────────────────────────────────────────────────────
const Chip: React.FC<{ color?: string; c: ReturnType<typeof palette>; mono?: boolean; title?: string; children: React.ReactNode }> = ({ color, c, mono, title, children }) => (
  <span title={title} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 8px', borderRadius: 999, fontSize: 11.5,
    fontWeight: 600, lineHeight: '18px', whiteSpace: 'nowrap', fontFamily: mono ? MONO : undefined,
    color: color || c.body, background: color ? `${color}14` : c.soft, border: `1px solid ${color ? `${color}40` : c.line}` }}>
    {children}
  </span>
);

const Section: React.FC<{ title: string; c: ReturnType<typeof palette>; right?: React.ReactNode; children: React.ReactNode; id?: string }> = ({ title, c, right, children, id }) => (
  <section id={id} style={{ background: c.card, border: `1px solid ${c.line}`, borderRadius: 10, padding: '14px 16px', marginBottom: 14 }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 }}>
      <h3 style={{ margin: 0, fontSize: 12, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: c.muted }}>{title}</h3>
      {right}
    </div>
    {children}
  </section>
);

const CopyButton: React.FC<{ text: string; c: ReturnType<typeof palette> }> = ({ text, c }) => {
  const [done, setDone] = useState(false);
  return (
    <button onClick={() => { navigator.clipboard?.writeText(text).then(() => { setDone(true); setTimeout(() => setDone(false), 1200); }).catch(() => {}); }}
      style={{ border: `1px solid ${c.line}`, background: c.card, color: c.muted, borderRadius: 6, fontSize: 11, padding: '2px 8px', cursor: 'pointer' }}>
      {done ? 'Copied' : 'Copy'}
    </button>
  );
};

// ─── universal evidence renderer ──────────────────────────────────────────────────────────────────────────────────
const MAX_ROWS = 25;

const Scalar: React.FC<{ v: any; c: ReturnType<typeof palette> }> = ({ v, c }) => {
  if (typeof v === 'boolean') return <Chip c={c} color={v ? '#16A34A' : '#64748B'}>{v ? 'Yes' : 'No'}</Chip>;
  if (typeof v === 'number') return <span style={{ fontVariantNumeric: 'tabular-nums' }}>{v.toLocaleString()}</span>;
  const s = clean(String(v));
  if (isUrl(s)) return <a href={s} target="_blank" rel="noopener noreferrer" style={{ color: c.blue, wordBreak: 'break-all' }}>{s}</a>;
  if (ISO_RE.test(s)) return <span>{fmtDate(s, s.length > 10)}</span>;
  if (looksLikeRecord(s) || s.length > 140) {
    return (
      <div style={{ position: 'relative' }}>
        <pre style={{ margin: 0, padding: '8px 10px', paddingRight: 64, background: c.code, border: `1px solid ${c.line}`, borderRadius: 6,
          fontFamily: MONO, fontSize: 11.5, color: c.ink, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{s}</pre>
        <div style={{ position: 'absolute', top: 6, right: 6 }}><CopyButton text={s} c={c} /></div>
      </div>
    );
  }
  return <span style={{ wordBreak: 'break-word' }}>{titleCase(s)}</span>;
};

const ShowMore: React.FC<{ total: number; shown: number; onClick: () => void; c: ReturnType<typeof palette> }> = ({ total, shown, onClick, c }) =>
  total > shown ? (
    <button onClick={onClick} style={{ marginTop: 6, border: 'none', background: 'none', color: c.blue, fontSize: 12, cursor: 'pointer', padding: 0 }}>
      Show all {total}
    </button>
  ) : null;

const ScalarList: React.FC<{ items: any[]; c: ReturnType<typeof palette> }> = ({ items, c }) => {
  const [all, setAll] = useState(false);
  const strs = items.map(i => clean(String(i))).filter(Boolean);
  const chips = strs.every(s => s.length <= 48 && !looksLikeRecord(s));
  const shown = all ? strs : strs.slice(0, chips ? 40 : MAX_ROWS);
  return (
    <div>
      {chips ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {shown.map((s, i) => <Chip key={i} c={c} mono={/^[\d.:/a-f]+$/i.test(s) || s.includes('.')}>{isUrl(s) ? <a href={s} target="_blank" rel="noopener noreferrer" style={{ color: c.blue }}>{s}</a> : s}</Chip>)}
        </div>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 18, display: 'grid', gap: 4 }}>
          {shown.map((s, i) => <li key={i} style={{ fontSize: 12.5, color: c.body, lineHeight: 1.5 }}><Scalar v={s} c={c} /></li>)}
        </ul>
      )}
      <ShowMore total={strs.length} shown={shown.length} onClick={() => setAll(true)} c={c} />
    </div>
  );
};

const short = (v: any): string => {
  if (v === null || v === undefined) return '';
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  if (Array.isArray(v)) return v.map(short).filter(Boolean).join(', ');
  if (typeof v === 'object') return Object.entries(v).filter(([, x]) => !isEmpty(x)).map(([k, x]) => `${humanize(k)}: ${short(x)}`).join(' · ');
  const s = clean(String(v));
  return ISO_RE.test(s) ? fmtDate(s) : s;
};

const ObjectTable: React.FC<{ rows: any[]; c: ReturnType<typeof palette> }> = ({ rows, c }) => {
  const [all, setAll] = useState(false);
  const cols = useMemo(() => {
    const freq = new Map<string, number>();
    rows.forEach(r => Object.entries(r || {}).forEach(([k, v]) => { if (!isEmpty(v)) freq.set(k, (freq.get(k) || 0) + 1); }));
    return Array.from(freq.entries()).sort((a, b) => b[1] - a[1]).slice(0, 7).map(([k]) => k);
  }, [rows]);
  const shown = all ? rows : rows.slice(0, MAX_ROWS);
  return (
    <div>
      <div style={{ overflowX: 'auto', border: `1px solid ${c.line}`, borderRadius: 8 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: c.soft }}>
              {cols.map(k => <th key={k} style={{ textAlign: 'left', padding: '7px 10px', fontWeight: 600, color: c.muted, whiteSpace: 'nowrap', borderBottom: `1px solid ${c.line}` }}>{humanize(k)}</th>)}
            </tr>
          </thead>
          <tbody>
            {shown.map((r, i) => (
              <tr key={i} style={{ borderBottom: i < shown.length - 1 ? `1px solid ${c.line}` : undefined }}>
                {cols.map(k => {
                  const v = r?.[k];
                  const text = short(v);
                  return (
                    <td key={k} style={{ padding: '7px 10px', color: c.ink, verticalAlign: 'top', maxWidth: 360,
                      fontFamily: typeof v === 'string' && (looksLikeRecord(v) || /^[\d.:]+$/.test(v)) ? MONO : undefined,
                      whiteSpace: text.length > 60 ? 'normal' : 'nowrap', wordBreak: text.length > 60 ? 'break-word' : undefined }}>
                      {typeof v === 'string' && isUrl(v) ? <a href={v} target="_blank" rel="noopener noreferrer" style={{ color: c.blue }}>{v}</a>
                        : typeof v === 'boolean' ? <Scalar v={v} c={c} /> : (text || <span style={{ color: c.faint }}>—</span>)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ShowMore total={rows.length} shown={shown.length} onClick={() => setAll(true)} c={c} />
    </div>
  );
};

const Value: React.FC<{ v: any; c: ReturnType<typeof palette>; depth: number }> = ({ v, c, depth }) => {
  if (Array.isArray(v)) {
    const items = v.filter(x => !isEmpty(x));
    if (items.every(x => typeof x !== 'object')) return <ScalarList items={items} c={c} />;
    if (items.every(x => x && typeof x === 'object' && !Array.isArray(x))) return <ObjectTable rows={items} c={c} />;
    return <ScalarList items={items.map(short)} c={c} />;
  }
  if (v && typeof v === 'object') {
    if (depth >= 3) return <Scalar v={JSON.stringify(v)} c={c} />;
    return <ObjectView obj={v} c={c} depth={depth + 1} />;
  }
  return <Scalar v={v} c={c} />;
};

const ObjectView: React.FC<{ obj: Record<string, any>; c: ReturnType<typeof palette>; depth: number; hide?: Set<string> }> = ({ obj, c, depth, hide }) => {
  const entries = Object.entries(obj).filter(([k, v]) => !(hide && hide.has(k)) && !isEmpty(v));
  const numbers = entries.filter(([, v]) => typeof v === 'number');
  const facts = entries.filter(([, v]) => typeof v === 'string' || typeof v === 'boolean');
  const nested = entries.filter(([, v]) => typeof v === 'object');
  const stats = depth === 0 && numbers.length > 0;
  const factRows = stats ? facts : [...numbers, ...facts];
  if (!entries.length) return null;
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 8 }}>
          {numbers.map(([k, v]) => (
            <div key={k} style={{ border: `1px solid ${c.line}`, borderRadius: 8, padding: '8px 10px' }}>
              <div style={{ fontSize: 18, fontWeight: 700, color: c.ink, fontVariantNumeric: 'tabular-nums' }}>{Number(v).toLocaleString()}</div>
              <div style={{ fontSize: 11, color: c.muted, marginTop: 2 }}>{humanize(k)}</div>
            </div>
          ))}
        </div>
      )}
      {factRows.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(110px, 180px) 1fr', columnGap: 14, rowGap: 8, fontSize: 12.5 }}>
          {factRows.map(([k, v]) => (
            <React.Fragment key={k}>
              <div style={{ color: c.muted }}>{humanize(k)}</div>
              <div style={{ color: c.ink, minWidth: 0 }}><Scalar v={v} c={c} /></div>
            </React.Fragment>
          ))}
        </div>
      )}
      {nested.map(([k, v]) => (
        <div key={k}>
          <div style={{ fontSize: 12, fontWeight: 700, color: c.ink, marginBottom: 6 }}>
            {humanize(k)}{Array.isArray(v) && <span style={{ color: c.faint, fontWeight: 500 }}> · {v.filter(x => !isEmpty(x)).length}</span>}
          </div>
          <div style={{ paddingLeft: depth > 0 ? 10 : 0, borderLeft: depth > 0 ? `2px solid ${c.line}` : undefined }}>
            <Value v={v} c={c} depth={depth} />
          </div>
        </div>
      ))}
    </div>
  );
};

const EvidenceView: React.FC<{ evidence: any; c: ReturnType<typeof palette> }> = ({ evidence, c }) => {
  if (isEmpty(evidence)) return <div style={{ fontSize: 12.5, color: c.muted }}>The scan recorded no further detail for this check.</div>;
  if (typeof evidence !== 'object') return <Scalar v={evidence} c={c} />;
  if (Array.isArray(evidence)) return <Value v={evidence} c={c} depth={0} />;
  const rest = Object.entries(evidence).filter(([k, v]) => !META_KEYS.has(k) && !isEmpty(v));
  if (!rest.length) return <div style={{ fontSize: 12.5, color: c.muted }}>The scan recorded no further detail beyond the result above.</div>;
  return <ObjectView obj={evidence} c={c} depth={0} hide={META_KEYS} />;
};

// ─── knowledge pieces ─────────────────────────────────────────────────────────────────────────────────────────────
const RELATION_COLOR: Record<string, string> = { defends: '#16A34A', enables: '#DC2626', indicates: '#9333EA', recon: '#0891B2' };

const TechniqueCard: React.FC<{ t: Technique; c: ReturnType<typeof palette> }> = ({ t, c }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border: `1px solid ${c.line}`, borderRadius: 8, padding: '10px 12px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
        <a href={t.url} target="_blank" rel="noopener noreferrer" style={{ fontFamily: MONO, fontSize: 12, fontWeight: 700, color: c.blue, textDecoration: 'none' }}>{t.id}</a>
        <span style={{ fontSize: 13, fontWeight: 600, color: c.ink }}>
          {t.parent_name ? <span style={{ color: c.muted, fontWeight: 500 }}>{t.parent_name}: </span> : null}{t.name || 'Name unavailable'}
        </span>
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
        <Chip c={c} color={RELATION_COLOR[t.relation]}>{t.relation_label}</Chip>
        {(t.tactics || []).map(x => <Chip key={x} c={c}>{x}</Chip>)}
        {t.matrix === 'ics' && <Chip c={c} color="#0891B2">ICS</Chip>}
      </div>
      <p style={{ margin: '8px 0 0', fontSize: 12.5, color: c.body, lineHeight: 1.5 }}>{t.why}</p>
      {(t.description || (t.mitigations && t.mitigations.length > 0)) && (
        <button onClick={() => setOpen(o => !o)} style={{ marginTop: 6, border: 'none', background: 'none', padding: 0, color: c.blue, fontSize: 12, cursor: 'pointer' }}>
          {open ? 'Hide MITRE detail' : `MITRE detail${t.mitigations?.length ? ` · ${t.mitigations.length} mitigations` : ''}`}
        </button>
      )}
      {open && (
        <div style={{ marginTop: 8, display: 'grid', gap: 8 }}>
          {t.description && <p style={{ margin: 0, fontSize: 12, color: c.muted, lineHeight: 1.5 }}>{t.description}</p>}
          {(t.mitigations || []).map(m => (
            <div key={m.id} style={{ fontSize: 12, lineHeight: 1.5 }}>
              <a href={m.url} target="_blank" rel="noopener noreferrer" style={{ fontFamily: MONO, color: c.blue, textDecoration: 'none' }}>{m.id}</a>
              <span style={{ color: c.ink, fontWeight: 600 }}> {m.name}</span>
              {m.how && <div style={{ color: c.muted }}>{m.how}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const cvssColor = (s?: number | null) => s == null ? '#64748B' : s >= 9 ? SEV.Critical : s >= 7 ? SEV.High : s >= 4 ? SEV.Medium : SEV.Low;

const CveTable: React.FC<{ rows: CveInfo[]; c: ReturnType<typeof palette> }> = ({ rows, c }) => {
  const [all, setAll] = useState(false);
  const sorted = [...rows].sort((a, b) => (Number(!!b.kev) - Number(!!a.kev)) || ((b.epss?.score ?? -1) - (a.epss?.score ?? -1)) || ((b.cvss?.score ?? -1) - (a.cvss?.score ?? -1)));
  const shown = all ? sorted : sorted.slice(0, 8);
  return (
    <div>
      <div style={{ display: 'grid', gap: 8 }}>
        {shown.map(v => (
          <div key={v.id} style={{ border: `1px solid ${c.line}`, borderRadius: 8, padding: '9px 12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <a href={v.url} target="_blank" rel="noopener noreferrer" style={{ fontFamily: MONO, fontSize: 12.5, fontWeight: 700, color: c.blue, textDecoration: 'none' }}>{v.id}</a>
              {v.cvss ? <Chip c={c} color={cvssColor(v.cvss.score)} title={v.cvss.vector}>CVSS {v.cvss.version} · {v.cvss.score}</Chip>
                : v.nvd_status === 'pending' ? <Chip c={c}>CVSS loading…</Chip> : v.nvd_status === 'not_found' ? <Chip c={c}>Not in NVD</Chip> : null}
              {v.epss && <Chip c={c} color={v.epss.percentile >= 0.9 ? SEV.High : undefined} title="FIRST EPSS: probability of exploitation in the next 30 days">
                EPSS {(v.epss.score * 100).toFixed(v.epss.score < 0.01 ? 2 : 1)}% · top {Math.max(1, Math.round((1 - v.epss.percentile) * 100))}%</Chip>}
              {v.kev && <Chip c={c} color={SEV.Critical} title={`Added to CISA KEV ${v.kev.date_added}`}>Known exploited</Chip>}
              {v.kev?.ransomware && <Chip c={c} color={SEV.Critical}>Used by ransomware</Chip>}
            </div>
            {v.description && <div style={{ fontSize: 12, color: c.body, marginTop: 5, lineHeight: 1.5 }}>{v.description}</div>}
            {v.kev && <div style={{ fontSize: 11.5, color: c.muted, marginTop: 4 }}>CISA: {v.kev.action}{v.kev.due_date ? ` (federal deadline ${fmtDate(v.kev.due_date)})` : ''}</div>}
          </div>
        ))}
      </div>
      <ShowMore total={sorted.length} shown={shown.length} onClick={() => setAll(true)} c={c} />
    </div>
  );
};

// ─── observed proof + re-check ─────────────────────────────────────────────────────────────────────────────────────
interface Recheck {
  id: string; scan_id: string; host: string; indicator_name: string; status: 'running' | 'done' | 'failed';
  method: 'direct' | 'shared' | 'group' | null;
  outcome: 'fixed' | 'still_failing' | 'now_failing' | 'passing' | 'not_tested' | 'changed' | null;
  previous: { severity: string; score_impact: number; value: string | null } | null;
  result: Indicator | null; error: string | null; started_at: string; finished_at: string | null;
  duration_ms: number | null; requested_by_name: string | null;
}

const ago = (iso?: string | null) => {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  const s = Math.max(0, Math.round((Date.now() - t) / 1000));
  if (isNaN(s)) return '';
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return fmtDate(iso, true);
};

// The raw records / headers / TLS facts a check judged (services/evidence_proof.py), shown first under "What we found".
const ObservedView: React.FC<{ observed: Record<string, any>; c: ReturnType<typeof palette>; caption: string }> = ({ observed, c, caption }) => {
  const { 'Observed at': at, Host: host, ...rest } = observed || {};
  return (
    <div style={{ border: `1px solid ${c.line}`, borderRadius: 8, padding: '10px 12px', marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: c.ink }}>Observed on {host || 'the host'}</span>
        <span style={{ fontSize: 11, color: c.faint }}>{caption}{at ? ` · ${fmtDate(at, true)}` : ''}</span>
      </div>
      <ObjectView obj={rest} c={c} depth={1} />
    </div>
  );
};

const OUTCOME: Record<string, { label: string; color: string; icon: string }> = {
  fixed: { label: 'Fixed: the check now passes', color: '#16A34A', icon: '✓' },
  passing: { label: 'Passing', color: '#16A34A', icon: '✓' },
  still_failing: { label: 'Still failing', color: '#DC2626', icon: '!' },
  changed: { label: 'Changed, still failing', color: '#D97706', icon: '!' },
  now_failing: { label: 'Now failing', color: '#DC2626', icon: '!' },
  not_tested: { label: "Couldn't be tested this time", color: '#64748B', icon: '–' },
};
const METHOD: Record<string, string> = { direct: 'this check only', shared: 'this check with its related checks', group: 'its whole check group' };

const RecheckPanel: React.FC<{ rechecks: Recheck[]; c: ReturnType<typeof palette>; starting: boolean; startError: string | null }> = ({ rechecks, c, starting, startError }) => {
  const [showDetail, setShowDetail] = useState(false);
  const latest = rechecks[0];
  if (!latest && !starting && !startError) return null;
  const running = starting || latest?.status === 'running';
  const o = latest?.outcome ? OUTCOME[latest.outcome] : null;
  const after = latest?.result;
  const afterValue = after?.evidence && typeof after.evidence === 'object' ? after.evidence.value : null;
  return (
    <Section title="Re-check" c={c} right={latest && !running ? <span style={{ fontSize: 11, color: c.faint }}>{ago(latest.finished_at || latest.started_at)}{latest.requested_by_name ? ` · by ${latest.requested_by_name}` : ''}</span> : undefined}>
      {startError && <div style={{ fontSize: 12.5, color: '#DC2626', marginBottom: 6 }}>{startError}</div>}
      {running ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: c.body }}>
          <span style={{ width: 16, height: 16, borderRadius: 99, border: `2px solid ${c.line}`, borderTopColor: '#2563EB', animation: 'idmspin .8s linear infinite' }} />
          Running this check again on {latest?.host || 'the host'}…
        </div>
      ) : latest?.status === 'failed' ? (
        <div style={{ fontSize: 12.5, color: c.body }}>The re-check could not run: {latest.error || 'unknown error'}.</div>
      ) : latest && o ? (
        <div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <span style={{ width: 24, height: 24, borderRadius: 99, background: o.color, color: '#fff', fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>{o.icon}</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: c.ink }}>{o.label}</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 14, rowGap: 4, fontSize: 12.5, marginTop: 10 }}>
            <span style={{ color: c.muted }}>In the scan</span>
            <span style={{ color: c.ink }}>{latest.previous ? <>{latest.previous.severity}{latest.previous.value ? ` · ${titleCase(clean(latest.previous.value))}` : ''}</> : '—'}</span>
            <span style={{ color: c.muted }}>Now</span>
            <span style={{ color: c.ink, fontWeight: 600 }}>{after ? <>{after.severity}{afterValue ? ` · ${titleCase(clean(String(afterValue)))}` : ''}</> : '—'}</span>
          </div>
          <div style={{ fontSize: 11.5, color: c.muted, marginTop: 8 }}>
            Ran {METHOD[latest.method || 'direct']}{latest.duration_ms != null ? ` in ${(latest.duration_ms / 1000).toFixed(1)}s` : ''}. The scan and its score stay as they are until the next full scan.
          </div>
          {after && (
            <button onClick={() => setShowDetail(v => !v)} style={{ marginTop: 6, border: 'none', background: 'none', padding: 0, color: c.blue, fontSize: 12, cursor: 'pointer' }}>
              {showDetail ? 'Hide re-check result' : 'Show re-check result'}
            </button>
          )}
          {showDetail && after && (
            <div style={{ marginTop: 10 }}>
              {after.evidence?.observed && <ObservedView observed={after.evidence.observed} c={c} caption="From the re-check" />}
              <EvidenceView evidence={after.evidence} c={c} />
            </div>
          )}
          {rechecks.length > 1 && (
            <div style={{ marginTop: 10, borderTop: `1px solid ${c.line}`, paddingTop: 8, display: 'grid', gap: 3 }}>
              {rechecks.slice(1).map(r => (
                <div key={r.id} style={{ fontSize: 11.5, color: c.muted }}>
                  {fmtDate(r.started_at, true)} · {r.status === 'done' && r.outcome ? OUTCOME[r.outcome].label : r.status === 'failed' ? 'Failed' : 'Running'}{r.requested_by_name ? ` · ${r.requested_by_name}` : ''}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </Section>
  );
};

// ─── main ─────────────────────────────────────────────────────────────────────────────────────────────────────────
export default function IndicatorDetailModal({ open, onClose, indicator, vendorName, domain, vendorId, scanId, list, onNavigate, variant = 'modal', scoreGain }: Props) {
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';
  const c = palette(isDark);
  const { user } = useAuth();
  const canEdit = !!user && user.role !== 'viewer';
  const [showRaw, setShowRaw] = useState(false);
  const [showRemediate, setShowRemediate] = useState(false);

  const name = indicator?.indicator_name || '';
  const intelQuery = useQuery({
    queryKey: ['scan', scanId, 'indicator-intel', domain || '', name, indicator?.category || ''],
    queryFn: async () => (await api.get('/v1/indicator-intel', { params: { scan_id: scanId, name, category: indicator?.category, target: domain || undefined } })).data as Intel,
    enabled: open && !!indicator && !!scanId,
    staleTime: 60_000,
    retry: false,
    // CVSS for CVEs NVD hasn't returned yet arrives in the background; ask again until it's all there.
    refetchInterval: q => {
      const k = (q.state.data as Intel | undefined)?.knowledge;
      const all = [...(k?.cves.found_in_evidence || []), ...(k?.cves.check_targets || []), ...(k?.kev_products?.items || [])];
      return all.some(v => v.nvd_status === 'pending') ? 8000 : false;
    },
  });
  const intel = intelQuery.data;

  // "Re-check this finding": runs this one check again on the host (services/single_check.py). Never changes the scan.
  const queryClient = useQueryClient();
  const recheckHost = domain || indicator?.endpoint_url || '';
  const rechecksKey = ['indicator-rechecks', recheckHost, name];
  const rechecksQuery = useQuery({
    queryKey: rechecksKey,
    queryFn: async () => (await api.get('/v1/indicator-intel/rechecks', { params: { host: recheckHost, name } })).data.rechecks as Recheck[],
    enabled: open && !!indicator && !!recheckHost,
    refetchInterval: q => ((q.state.data as Recheck[] | undefined)?.[0]?.status === 'running' ? 1500 : false),
  });
  const rechecks = rechecksQuery.data || [];
  const recheckMutation = useMutation({
    mutationFn: async () => (await api.post('/v1/indicator-intel/recheck', { scan_id: scanId, name, category: indicator?.category, target: domain || undefined })).data as Recheck,
    onSuccess: row => queryClient.setQueryData(rechecksKey, (old: Recheck[] | undefined) => [row, ...(old || []).filter(r => r.id !== row.id)]),
  });
  const recheckRunning = recheckMutation.isPending || rechecks[0]?.status === 'running';
  const recheckError = recheckMutation.isError
    ? (() => {
        const d = (recheckMutation.error as any)?.response?.data?.detail;
        return typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : "Couldn't start the re-check";
      })()
    : null;
  useEffect(() => { recheckMutation.reset(); }, [indicator]); // eslint-disable-line react-hooks/exhaustive-deps

  const idx = list && indicator ? list.findIndex(i => i === indicator || (i.indicator_name === indicator.indicator_name && i.category === indicator.category)) : -1;
  const prev = idx > 0 ? list![idx - 1] : null;
  const next = idx >= 0 && list && idx < list.length - 1 ? list[idx + 1] : null;

  useEffect(() => { setShowRaw(false); }, [indicator]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (showRemediate) return;
      if ((e.target as HTMLElement)?.closest?.('input, textarea, select')) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && prev && onNavigate) onNavigate(prev);
      if (e.key === 'ArrowRight' && next && onNavigate) onNavigate(next);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, prev, next, onNavigate, onClose, showRemediate]);

  if (!open || !indicator) return null;

  const ev = indicator.evidence;
  const evObj = ev && typeof ev === 'object' && !Array.isArray(ev) ? ev : {};
  const resultValue = evObj.value != null && evObj.value !== '' ? clean(String(evObj.value)) : null;
  const rating = evObj.rating != null && evObj.rating !== '' ? clean(String(evObj.rating)) : null;
  const notTested = NOT_TESTED_RE.test(`${resultValue || ''} ${rating || ''}`);
  const failing = ['Critical', 'High', 'Medium', 'Low'].includes(indicator.severity) && !notTested;
  const rem = intel?.remediation;
  const inRemediation = !!rem && rem.status !== 'completed' && rem.risk_status !== 'fixed';
  const status = inRemediation ? { label: 'In remediation', color: '#7C3AED' }
    : failing ? { label: 'Open', color: SEV[indicator.severity] }
    : notTested ? { label: 'Not tested', color: '#64748B' }
    : { label: 'Passed', color: '#16A34A' };

  const paragraphs = (indicator.description || '').split(/\n\s*\n/).map(p => p.trim()).filter(Boolean);
  const checked = paragraphs[0] ? clean(paragraphs[0]) : null;
  const verdict = paragraphs.length > 1 ? clean(paragraphs.slice(1).join('\n')).replace(/^[A-Z][A-Z /-]{2,24}:\s*/, '') : null;
  const fix = !GENERIC_FIX.test(indicator.recommendation || '') ? clean(indicator.recommendation) : null;
  const impact = Number(indicator.score_impact) || 0;
  const k = intel?.knowledge;
  const techniques = k?.attack.techniques || [];
  const weaknesses = k?.cwe.weaknesses || [];
  const mitreGuidance = failing && !fix
    ? [...weaknesses.flatMap(w => (w.mitigations || []).slice(0, 2).map(m => ({ src: w.id, url: w.url, text: m.text, phase: m.phase })))].slice(0, 4)
    : [];
  const cvesFound = k?.cves.found_in_evidence || [];
  const cveTargets = k?.cves.check_targets || [];
  const kevProducts = k?.kev_products;
  const sourceText = evObj.source ? clean(String(evObj.source)) : null;
  const confidence = evObj.confidence ? titleCase(String(evObj.confidence)) : null;
  const ip = evObj.ip || evObj.ip_address || null;
  const host = intel?.host || domain || indicator.endpoint_url || null;

  // History (newest first from the API): how long the current state has held.
  const history = intel?.history || [];
  const isFail = (h: Intel['history'][number]) => h.present && ['Critical', 'High', 'Medium', 'Low'].includes(h.severity || '') && !NOT_TESTED_RE.test(h.value || '');
  // Colour of one past result: failing = its severity, passing = green, not testable / absent = grey.
  const histColor = (h: Intel['history'][number]) => !h.present || NOT_TESTED_RE.test(h.value || '') ? '#94A3B8'
    : isFail(h) ? SEV[h.severity || 'Low'] || SEV.Low : '#16A34A';
  const histLabel = (h: Intel['history'][number]) => !h.present ? 'Not checked' : NOT_TESTED_RE.test(h.value || '') ? 'Not tested'
    : isFail(h) ? (h.severity || 'Failing') : 'Passed';
  let streak = 0;
  for (const h of history) { if (h.present && isFail(h) === failing) streak++; else break; }
  const since = streak > 0 ? history[streak - 1] : null;
  const fixedAfter = !failing && history.length > streak && history[streak] && isFail(history[streak]);

  const exportFinding = () => {
    const payload = { exported_at: new Date().toISOString(), vendor: vendorName, host, scan: intel ? { id: intel.scan_id, ref: intel.scan_ref, type: intel.scan_type, scanned_at: intel.scanned_at } : { id: scanId },
      finding: indicator, status: status.label, mappings: k ? { kind: k.kind, attack: techniques.map(t => ({ id: t.id, name: t.name, relation: t.relation, why: t.why })),
        cwe: weaknesses.map(w => ({ id: w.id, name: w.name })), owasp_2021: k.cwe.owasp_2021, frameworks: intel?.frameworks } : null,
      vulnerabilities: [...cvesFound, ...cveTargets].map(v => ({ id: v.id, cvss: v.cvss, epss: v.epss, kev: !!v.kev })), history };
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' }));
    a.download = `${(intel?.scan_ref || 'scan')}_${indicator.indicator_name.replace(/[^\w]+/g, '_')}.json`;
    a.click();
  };

  const btn = (primary = false): React.CSSProperties => ({
    padding: '7px 14px', borderRadius: 7, fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
    background: primary ? '#2563EB' : c.card, color: primary ? '#fff' : c.ink, border: `1px solid ${primary ? '#2563EB' : c.line}`,
  });
  const navBtn = (enabled: boolean): React.CSSProperties => ({
    width: 30, height: 30, borderRadius: 7, border: `1px solid ${c.line}`, background: c.card, color: enabled ? c.ink : c.faint,
    cursor: enabled ? 'pointer' : 'default', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center',
  });

  return (
    <>
      <div onClick={onClose} className={variant === 'drawer' ? 'idm-drawer' : undefined}
        style={variant === 'drawer'
          ? { position: 'fixed', top: 64, left: 0, right: 0, bottom: 0, zIndex: 1300, background: 'rgba(15, 23, 42, 0.22)', display: 'flex', justifyContent: 'flex-end' }
          : { position: 'fixed', inset: 0, zIndex: 1300, background: 'rgba(15, 23, 42, 0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div onClick={e => e.stopPropagation()} role="dialog" aria-label={indicator.indicator_name}
          style={variant === 'drawer'
            ? { width: 'min(760px, 100vw)', height: '100%', display: 'flex', flexDirection: 'column', background: c.page,
                borderLeft: `1px solid ${c.line}`, overflow: 'hidden', animation: 'idmSlideIn .18s ease-out' }
            : { width: '100%', maxWidth: 1120, height: 'min(92vh, 980px)', display: 'flex', flexDirection: 'column', background: c.page,
                borderRadius: 12, border: `1px solid ${c.line}`, overflow: 'hidden', boxShadow: '0 24px 48px rgba(0,0,0,.18)' }}>

          {/* Header */}
          <div style={{ padding: '14px 18px', background: c.card, borderBottom: `1px solid ${c.line}` }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <h2 style={{ margin: 0, fontSize: 19, fontWeight: 700, color: c.ink }}>{indicator.indicator_name}</h2>
                  <Chip c={c} color={SEV[indicator.severity] || SEV.Info}><span style={{ width: 7, height: 7, borderRadius: 9, background: SEV[indicator.severity] || SEV.Info }} />{indicator.severity}</Chip>
                  <Chip c={c} color={status.color}>{status.label}</Chip>
                  <Chip c={c}>{indicator.category}</Chip>
                  {indicator.is_applicable === false && <Chip c={c} color="#64748B">Non-production host · not scored</Chip>}
                </div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6, fontSize: 12, color: c.muted }}>
                  {[vendorName, host, intel?.scan_ref && <span key="r" style={{ fontFamily: MONO }}>{intel.scan_ref}</span>,
                    intel?.scan_type && `${titleCase(intel.scan_type)} scan`, intel?.scanned_at && fmtDate(intel.scanned_at, true)]
                    .filter(Boolean).map((x, i, arr) => <React.Fragment key={i}>{x}{i < arr.length - 1 && <span style={{ color: c.faint }}>·</span>}</React.Fragment>)}
                </div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div style={{ fontSize: 22, fontWeight: 800, color: impact < 0 ? SEV[indicator.severity] || c.ink : c.ink, fontVariantNumeric: 'tabular-nums' }}>
                  {impact < 0 ? `−${Math.abs(impact).toFixed(Math.abs(impact) % 1 ? 1 : 0)}` : '0'}
                </div>
                <div style={{ fontSize: 11, color: c.muted }}>{impact < 0 ? 'points off the score' : 'no score impact'}</div>
                {typeof scoreGain === 'number' && scoreGain > 0 && (
                  <div title="How much the overall rating would rise if only this finding were fixed"
                    style={{ marginTop: 4, display: 'inline-block', fontSize: 11.5, fontWeight: 700, color: '#185FA5', background: '#E6F1FB', borderRadius: 6, padding: '2px 7px' }}>
                    +{scoreGain} pts if fixed
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0 }}>
                {list && onNavigate && idx >= 0 && (
                  <>
                    <button style={navBtn(!!prev)} disabled={!prev} onClick={() => prev && onNavigate(prev)} title="Previous (←)">‹</button>
                    <span style={{ fontSize: 11.5, color: c.muted, minWidth: 46, textAlign: 'center' }}>{idx + 1} of {list.length}</span>
                    <button style={navBtn(!!next)} disabled={!next} onClick={() => next && onNavigate(next)} title="Next (→)">›</button>
                  </>
                )}
                <button style={navBtn(true)} onClick={onClose} title="Close (Esc)">×</button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="idm-body" style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            <div className="idm-grid">
              <div style={{ minWidth: 0 }}>
                <RecheckPanel rechecks={rechecks} c={c} starting={recheckMutation.isPending} startError={recheckError} />

                {/* Verdict */}
                <Section title="Result" c={c} right={rating && resultValue && rating.toUpperCase() !== resultValue.toUpperCase() ? <Chip c={c}>{titleCase(rating)}</Chip> : undefined}>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <span style={{ width: 28, height: 28, borderRadius: 999, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#fff', fontSize: 14, fontWeight: 800, background: status.color }}>
                      {status.label === 'Passed' ? '✓' : status.label === 'Not tested' ? '–' : '!'}
                    </span>
                    <div style={{ minWidth: 0 }}>
                      {(resultValue || rating) && <div style={{ fontSize: 15, fontWeight: 700, color: c.ink }}>{titleCase(resultValue || rating || '')}</div>}
                      {verdict && <p style={{ margin: '4px 0 0', fontSize: 13, color: c.body, lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{verdict}</p>}
                      {(sourceText || confidence || ip || indicator.protocol) && (
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
                          {sourceText && <Chip c={c}>Source: {sourceText}</Chip>}
                          {confidence && <Chip c={c}>Confidence: {confidence}</Chip>}
                          {ip && <Chip c={c} mono>{String(ip)}</Chip>}
                          {indicator.protocol && <Chip c={c}>{String(indicator.protocol).toUpperCase()}</Chip>}
                        </div>
                      )}
                      {rem && (
                        <div style={{ marginTop: 8, fontSize: 12.5, color: c.body }}>
                          {rem.status === 'completed' ? 'Remediation request completed: ' : 'In remediation request '}
                          <a href={`/remediation/${rem.id}`} style={{ color: c.blue }}>{rem.title}</a>
                          {rem.due_date && rem.status !== 'completed' ? ` · due ${fmtDate(rem.due_date)}` : ''}
                        </div>
                      )}
                    </div>
                  </div>
                </Section>

                {/* Evidence */}
                <Section title="What we found" c={c} right={!isEmpty(ev) ? (
                  <button onClick={() => setShowRaw(r => !r)} style={{ border: `1px solid ${c.line}`, background: c.card, color: c.muted, borderRadius: 6, fontSize: 11, padding: '2px 8px', cursor: 'pointer' }}>
                    {showRaw ? 'Formatted' : 'Raw data'}
                  </button>) : undefined}>
                  {showRaw ? (
                    <div style={{ position: 'relative' }}>
                      <pre style={{ margin: 0, maxHeight: 420, overflow: 'auto', padding: 12, background: c.code, border: `1px solid ${c.line}`, borderRadius: 8, fontFamily: MONO, fontSize: 11.5, color: c.ink }}>
                        {JSON.stringify(ev, null, 2)}
                      </pre>
                      <div style={{ position: 'absolute', top: 8, right: 8 }}><CopyButton text={JSON.stringify(ev, null, 2)} c={c} /></div>
                    </div>
                  ) : (
                    <>
                      {evObj.observed ? <ObservedView observed={evObj.observed} c={c} caption="During this scan" />
                        : rechecks[0]?.result?.evidence?.observed ? <ObservedView observed={rechecks[0].result.evidence.observed} c={c} caption="From the latest re-check" />
                        : null}
                      <EvidenceView evidence={ev} c={c} />
                    </>
                  )}
                </Section>

                {/* Vulnerabilities */}
                {(cvesFound.length > 0 || cveTargets.length > 0 || (kevProducts && kevProducts.total > 0)) && (
                  <Section title="Vulnerabilities" c={c} right={<span style={{ fontSize: 11, color: c.faint }}>CISA KEV · FIRST EPSS · NVD</span>}>
                    {cvesFound.length > 0 && (
                      <div style={{ marginBottom: 12 }}>
                        <div style={{ fontSize: 12.5, fontWeight: 600, color: c.ink, marginBottom: 6 }}>
                          Reported in this finding{k && k.cves.evidence_total > cvesFound.length ? ` (${cvesFound.length} of ${k.cves.evidence_total})` : ` (${cvesFound.length})`}
                        </div>
                        <CveTable rows={cvesFound} c={c} />
                      </div>
                    )}
                    {cveTargets.length > 0 && (
                      <div style={{ marginBottom: 12 }}>
                        <div style={{ fontSize: 12.5, fontWeight: 600, color: c.ink, marginBottom: 6 }}>What this check looks for</div>
                        <CveTable rows={cveTargets} c={c} />
                      </div>
                    )}
                    {kevProducts && kevProducts.total > 0 && (
                      <div>
                        <div style={{ fontSize: 12.5, fontWeight: 600, color: c.ink, marginBottom: 2 }}>
                          Known exploited vulnerabilities in this product: {kevProducts.total}{kevProducts.ransomware ? ` (${kevProducts.ransomware} used by ransomware)` : ''}
                        </div>
                        <div style={{ fontSize: 11.5, color: c.muted, marginBottom: 6 }}>
                          From CISA's catalogue. They show what attackers target in this product; the scan detected the product, not these specific flaws.
                        </div>
                        <CveTable rows={kevProducts.items.map(i => ({ ...i, id: i.cve, url: i.url || `https://nvd.nist.gov/vuln/detail/${i.cve}`,
                          description: i.name, kev: { date_added: i.date_added, due_date: '', ransomware: i.ransomware, name: i.name, action: '' } } as any))} c={c} />
                      </div>
                    )}
                  </Section>
                )}

                {/* What we checked */}
                {checked && (
                  <Section title="What this check means" c={c}>
                    <p style={{ margin: 0, fontSize: 13, color: c.body, lineHeight: 1.6 }}>{checked}</p>
                  </Section>
                )}

                {/* How to fix */}
                {failing && (fix || mitreGuidance.length > 0) && (
                  <Section title="How to fix" c={c}>
                    {fix && <p style={{ margin: 0, fontSize: 13, color: c.ink, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{fix}</p>}
                    {!fix && (
                      <div style={{ display: 'grid', gap: 8 }}>
                        <div style={{ fontSize: 11.5, color: c.muted }}>Guidance from MITRE for the weaknesses behind this finding:</div>
                        {mitreGuidance.map((g, i) => (
                          <div key={i} style={{ fontSize: 12.5, color: c.body, lineHeight: 1.55 }}>
                            <a href={g.url} target="_blank" rel="noopener noreferrer" style={{ fontFamily: MONO, color: c.blue, textDecoration: 'none' }}>{g.src}</a>
                            {g.phase && <span style={{ color: c.faint }}> · {g.phase}</span>}
                            <div>{g.text}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </Section>
                )}

                {/* History */}
                {history.length > 0 && (
                  <Section title="History" c={c} right={<span style={{ fontSize: 11, color: c.faint }}>Last {history.length} scans of {intel?.host}</span>}>
                    {since && (
                      <div style={{ fontSize: 12.5, color: c.body, marginBottom: 10 }}>
                        {failing ? 'Failing' : notTested ? 'Not testable' : 'Passing'} in the last {streak} scan{streak === 1 ? '' : 's'}, since {fmtDate(since.date)}
                        {fixedAfter ? ` — it was failing before that (${history[streak].ref || fmtDate(history[streak].date)}).` : '.'}
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: 4, alignItems: 'flex-end', marginBottom: 10 }}>
                      {[...history].reverse().map(h => (
                        <div key={h.scan_id} title={`${h.ref || ''} ${fmtDate(h.date)}: ${histLabel(h)}${h.present && h.value ? ` · ${h.value}` : ''}`}
                          style={{ flex: 1, maxWidth: 40, height: 22, borderRadius: 4, background: histColor(h),
                            opacity: h.scan_id === intel?.scan_id ? 1 : 0.55, outline: h.scan_id === intel?.scan_id ? `2px solid ${c.ink}` : undefined, outlineOffset: 1 }} />
                      ))}
                    </div>
                    <div style={{ border: `1px solid ${c.line}`, borderRadius: 8, overflow: 'hidden' }}>
                      {history.slice(0, 6).map((h, i) => (
                        <div key={h.scan_id} style={{ display: 'grid', gridTemplateColumns: '96px 110px 80px 1fr', gap: 10, alignItems: 'center', padding: '7px 10px', fontSize: 12,
                          borderTop: i ? `1px solid ${c.line}` : undefined, background: h.scan_id === intel?.scan_id ? c.soft : undefined }}>
                          <span style={{ fontFamily: MONO, color: c.muted }}>{h.ref || '—'}</span>
                          <span style={{ color: c.ink }}>{fmtDate(h.date)}</span>
                          <span>{h.present ? <Chip c={c} color={histColor(h)}>{histLabel(h)}</Chip> : <span style={{ color: c.faint }}>Not checked</span>}</span>
                          <span style={{ color: c.body, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{h.value ? titleCase(clean(h.value)) : ''}</span>
                        </div>
                      ))}
                    </div>
                  </Section>
                )}
              </div>

              {/* Side: standards */}
              <div style={{ minWidth: 0 }}>
                {intelQuery.isPending && (
                  <Section title="Standards" c={c}>
                    {[0, 1, 2].map(i => <div key={i} style={{ height: 54, borderRadius: 8, background: c.soft, marginBottom: 8 }} />)}
                  </Section>
                )}
                {intelQuery.isError && (
                  <Section title="Standards" c={c}>
                    <div style={{ fontSize: 12.5, color: c.muted }}>
                      {(intelQuery.error as any)?.response?.status === 404 ? "This finding isn't available on your plan or in this scan." : "Couldn't load mappings. Try again in a moment."}
                    </div>
                  </Section>
                )}
                {intel && !k && (
                  <Section title="Standards" c={c}><div style={{ fontSize: 12.5, color: c.muted }}>This check isn't in the FluxWatch catalogue yet.</div></Section>
                )}
                {k && (
                  <>
                    {k.note && (
                      <Section title={k.kind === 'business' ? 'About this check' : k.kind === 'composite' ? 'Summary score' : 'Note'} c={c}>
                        <p style={{ margin: 0, fontSize: 12.5, color: c.body, lineHeight: 1.55 }}>{k.note}</p>
                      </Section>
                    )}
                    {techniques.length > 0 && (
                      <Section title="MITRE ATT&CK" c={c} right={k.attack.version ? <span style={{ fontSize: 11, color: c.faint }}>v{k.attack.version}</span> : undefined}>
                        <div style={{ display: 'grid', gap: 8 }}>{techniques.map(t => <TechniqueCard key={t.id + t.relation} t={t} c={c} />)}</div>
                      </Section>
                    )}
                    {weaknesses.length > 0 && (
                      <Section title="Weaknesses (CWE)" c={c} right={k.cwe.version ? <span style={{ fontSize: 11, color: c.faint }}>v{k.cwe.version}</span> : undefined}>
                        <div style={{ display: 'grid', gap: 8 }}>
                          {weaknesses.map(w => (
                            <div key={w.id} style={{ fontSize: 12.5, lineHeight: 1.45 }}>
                              <a href={w.url} target="_blank" rel="noopener noreferrer" style={{ fontFamily: MONO, fontWeight: 700, color: c.blue, textDecoration: 'none' }}>{w.id}</a>
                              <span style={{ color: c.ink }}> {w.name || ''}</span>
                            </div>
                          ))}
                        </div>
                        {k.cwe.owasp_2021.length > 0 && (
                          <div style={{ marginTop: 10 }}>
                            <div style={{ fontSize: 11, color: c.muted, marginBottom: 5 }}>OWASP Top 10 (2021), as assigned by MITRE</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>{k.cwe.owasp_2021.map(o => <Chip key={o} c={c} color="#0891B2">{o}</Chip>)}</div>
                          </div>
                        )}
                      </Section>
                    )}
                  </>
                )}
                {intel && intel.frameworks.length > 0 && (
                  <Section title="Framework controls" c={c} right={<span style={{ fontSize: 11, color: c.faint }}>Same as Security Profile</span>}>
                    <div style={{ display: 'grid', gap: 10 }}>
                      {intel.frameworks.map(f => (
                        <div key={f.framework}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: c.ink, marginBottom: 5 }}>{f.framework}</div>
                          <div style={{ display: 'grid', gap: 4 }}>
                            {f.controls.map(ctl => (
                              <div key={ctl.id} style={{ display: 'flex', gap: 8, fontSize: 12, lineHeight: 1.4 }}>
                                <span style={{ fontFamily: MONO, color: c.blue, fontWeight: 600, minWidth: 56 }}>{ctl.id}</span>
                                <span style={{ color: c.body }}>{ctl.title}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Section>
                )}
                {k && !techniques.length && !weaknesses.length && !k.note && !(intel?.frameworks.length) && (
                  <Section title="Standards" c={c}><div style={{ fontSize: 12.5, color: c.muted }}>No standard mapping applies to this check.</div></Section>
                )}
                {k && (
                  <div style={{ fontSize: 11, color: c.faint, lineHeight: 1.5, padding: '0 4px' }}>
                    Mappings are FluxWatch's reviewed catalogue, checked against MITRE's published ATT&CK and CWE data. Vulnerability facts are live from CISA, FIRST and NIST NVD.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{ padding: '10px 16px', background: c.card, borderTop: `1px solid ${c.line}`, display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            {canEdit && scanId && (
              <button style={{ ...btn(), marginRight: 'auto', opacity: recheckRunning ? 0.6 : 1, cursor: recheckRunning ? 'default' : 'pointer' }}
                disabled={recheckRunning} onClick={() => recheckMutation.mutate()} title="Run just this check again on the host now">
                {recheckRunning ? 'Re-checking…' : rechecks.length ? 'Re-check again' : 'Re-check now'}
              </button>
            )}
            <button style={btn()} onClick={exportFinding}>Export</button>
            {failing && canEdit && vendorId && !inRemediation && <button style={btn(true)} onClick={() => setShowRemediate(true)}>Request remediation</button>}
            <button style={btn()} onClick={onClose}>Close</button>
          </div>
        </div>
      </div>

      <style>{`
        .idm-grid { display: grid; grid-template-columns: minmax(0, 1fr) 360px; gap: 14px; align-items: start; }
        .idm-drawer .idm-grid { grid-template-columns: minmax(0, 1fr); }
        @keyframes idmSlideIn { from { transform: translateX(40px); opacity: 0; } to { transform: none; opacity: 1; } }
        @media (max-width: 920px) { .idm-grid { grid-template-columns: minmax(0, 1fr); } }
        @keyframes idmspin { to { transform: rotate(360deg); } }
      `}</style>

      <React.Suspense fallback={null}>
        {showRemediate && vendorId && (
          <RequestRemediationModal isDark={isDark} onClose={() => setShowRemediate(false)} onCreated={() => { setShowRemediate(false); intelQuery.refetch(); }}
            vendor={{ id: vendorId, name: vendorName || host || '', domain: domain || null }} preselected={[indicator.indicator_name]} />
        )}
      </React.Suspense>
    </>
  );
}
